import { RequireSignedOut } from '@/components/auth/RequireSignedOut'
import { SignInFeature } from '@/features/auth/signin'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/sign-in')({
  component: SignInRoute,
})

function SignInRoute() {
  return (
    <RequireSignedOut>
      <SignInFeature />
    </RequireSignedOut>
  )
}
